if (!window.__mpSwatchMoreInit) {
  window.__mpSwatchMoreInit = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-swatch-toggle]');
    if (!btn) return;

    const targetId = btn.getAttribute('aria-controls');
    const target = targetId ? document.getElementById(targetId) : null;

    if (!target) return;

    const expanded = target.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });
}
